import React, { useCallback, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import Files from './Results/Files';
import Folders from './Results/Folders';
import { getMoreResults } from '../api';
import CustomAlert from './CustomAlert';
import AddButton from './AddButton';
import CancelButton from './CancelButton';
import Filters from './Results/Filters';
import SelectedFilters from './SelectedFilters';

const Results = props => {
  const {
    data,
    setPaginationLoading,
    setError,
    setData,
    error,
    loading,
    setLoading,
    selectedFilters,
    setSelectedFilters,
    initialData,
    setInitialData,
    paginationLoading,
    setBreadCrumb,
  } = props;

  const { folders, media, totalCount, next, facets } = data || {};

  const [selectedImage, setSelectedImage] = useState(null);

  const handleFetchMore = useCallback(
    nextUrl => {
      if (!nextUrl) return;

      setPaginationLoading(true);
      setError('');

      getMoreResults(nextUrl)
        .then(response => {
          const {
            data: { media: newMedia, ...rest },
          } = response;

          setData(prev => ({
            ...prev,
            ...rest,
            media: [...prev.media, ...newMedia],
          }));
        })
        .catch(err => setError(err.message))
        .finally(() => setPaginationLoading(false));
    },
    [setData, setError, setPaginationLoading]
  );

  const handleFilterRemove = useCallback(() => {
    setSelectedFilters([]);

    const {
      facets: initialFacets,
      media: initialMedia,
      totalCount: initialTotalCount,
      next: initialNext,
    } = initialData;

    setData(prev => ({
      ...prev,
      facets: initialFacets,
      media: initialMedia,
      totalCount: initialTotalCount,
      next: initialNext,
    }));
  }, [initialData, setData, setSelectedFilters]);

  const noMediaResult = useMemo(
    () => !loading && data && data?.media && data.media.length === 0,
    [data, loading]
  );

  if (error) return <CustomAlert message={error} severity="error" />;

  return (
    <>
      {!!folders && (
        <Folders
          folders={folders}
          setData={setData}
          setError={setError}
          setLoading={setLoading}
          setInitialData={setInitialData}
          setBreadCrumb={setBreadCrumb}
          setSelectedFilters={setSelectedFilters}
        />
      )}

      {!!selectedFilters?.length && (
        <SelectedFilters
          selectedFilters={selectedFilters}
          handleFilterRemove={handleFilterRemove}
        />
      )}

      <Filters
        facets={facets}
        setData={setData}
        setError={setError}
        setLoading={setLoading}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        initialData={initialData}
      />

      <Files
        media={media}
        totalCount={totalCount}
        next={next}
        handleFetchMore={handleFetchMore}
        selectedImage={selectedImage}
        setSelectedImage={setSelectedImage}
        noMediaResult={noMediaResult}
        paginationLoading={paginationLoading}
      />

      <Box display="flex" justifyContent="flex-end" mt={3} gap={3}>
        {selectedImage && <AddButton selectedImage={selectedImage} />}
        <CancelButton />
      </Box>
    </>
  );
};

export default Results;
